import axios from 'axios';
import api from '@motionelements/core/src/api/base-api-v2';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string.js';

let orderPreviewCancelToken = null;

export const getOrderPreview = async (params) => {
  if (!orderPreviewCancelToken) {
    orderPreviewCancelToken = axios.CancelToken.source();
  } else {
    orderPreviewCancelToken.cancel();
    orderPreviewCancelToken = axios.CancelToken.source();
  }
  const url = '/v2/orders/preview';
  const withCredentials = _.get(params.orderType) !== 'on_demand';
  return api.get(url, {
    withCredentials: withCredentials,
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
    cancelToken: orderPreviewCancelToken.token,
  });
};

export const createOrder = async (params) => {
  const url = '/v2/orders';
  return api.request('post', url, {
    data: params,
    params: api.getLocaleParams(),
  });
};

export const createCheckoutSession = async (params) => {
  const url = '/v2/orders/checkout-session';
  return api.request('post', url, {
    data: params,
    params: api.getLocaleParams(),
  });
};

/*
export const createStripeSetupIntent = async (params) => {
  const url = '/v2/orders/setup-intent';
  return api.request('post', url, {
    data: {
      ...params,
    },
    params: api.getLocaleParams(),
  });
};
 */

export const createPaymentIntent = async (params) => {
  const url = '/v2/orders/payment-intent';
  return api.request('post', url, {
    data: {
      ...params,
    },
    params: api.getLocaleParams(),
  });
};

export const confirmPaymentIntent = async (params) => {
  const url = '/v2/orders/payment-intent/confirm';
  return api.request('post', url, {
    data: {
      ...params,
    },
    params: api.getLocaleParams(),
  });
};

export const completeOrder = async (id, params) => {
  const url = `/v2/orders/${id}/complete`;
  return api.request('patch', url, {
    data: params,
    params: api.getLocaleParams(),
  });
};

export const trackOrder = async (id) => {
  const url = `/v2/orders/${id}/track`;
  return api.request('patch', url, {
    params: api.getLocaleParams(),
  });
};


/*
async function withPolling(callback, interval) {
  const data = await callback();

  // If no polling interval is given we
  // return a regular object with the data.
  if (!interval) return { data };

  // Otherwise, we create a new `Vue.observable()`
  // instance and refetch the data according to
  // the specified polling interval.
  const observableData = Vue.observable({ data });
  const poll = () => setTimeout(async () => {
    observableData.data = { ...(await callback()) };
    poll();
  }, interval);

  const timerID = poll();

  console.log('timer', timerID);

  return observableData;
}

export const pollOrderCompleted = async (id, params) => {
  const url = `/v2/orders/${id}/completed`;
  const interval = 2000;
  const response = withPolling(() => api.request('patch', url, {
    data: params,
    params: api.getLocaleParams(),
  }), interval);
  console.log(response);
  return response;
};
 */

export const checkoutOrderWithStripePaymentMethod = async (id, params) => {
  const url = `/v2/orders/${id}/checkout`;
  return api.request('patch', url, {
    data: params,
    params: api.getLocaleParams(),
  });
};


export const createOrderAndCheckout = async (params) => {
  const url = '/v2/orders/checkout';
  return api.request('post', url, {
    data: snakeCaseKeys(params),
    params: api.getLocaleParams(),
  });
};


export const getOrder = async (id, params) => api.get(`/v2/orders/${id}`, {
  params: {
    ...api.getLocaleParams(),
    ...params,
  },
});

// eslint-disable-next-line
export const downloadOrderReceiptPdf = (id) => {
  return api.get(`/v2/orders/${id}/receipt`, {
    params: {
      ...api.getLocaleParams(),
    },
    responseType: 'blob',
    headers: {
      Accept: 'application/pdf', // use Accept header to download pdf
    },
  });
};
